<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <v-text-field
                            v-if="inserindo"
                            name="Nome Completo"
                            v-model="value.nome"
                            v-validate="'required'"
                            :error-messages="errors.collect('Nome Completo')"
                            label="Nome Completo"
                            placeholder="Ex. Roberto Farias Souza"
                    ></v-text-field>
                    <div class="az-text usuario-dados-nome" v-else>
                        <label>Nome Completo</label>
                        <p>{{value.nome}}</p>
                    </div>
                </v-flex>
                <v-flex xs12 sm4 d-flex>
                    <v-text-field
                            v-if="inserindo"
                            label="CPF"
                            name="CPF"
                            v-model="value.docChave"
                            v-validate="'required'"
                            :error-messages="errors.collect('CPF')"
                            placeholder="000.000.000-00"
                            mask="###.###.###-##"
                    ></v-text-field>
                    <div class="az-text usuario-dados-doc" v-else>
                        <label>CPF</label>
                        <p>{{ value.docChave | az-cpf-cnpj }}</p>
                    </div>
                </v-flex>
                <v-flex xs12 sm4 d-flex>
                    <v-text-field
                            v-if="inserindo"
                            v-model="value.email"
                            required
                            label="E-mail"
                            name="E-mail"
                            v-validate="'required|email'"
                            :error-messages="errors.collect('E-mail')"
                            placeholder="Ex. rofarias@gmail.com"
                    ></v-text-field>
                    <div class="az-text usuario-dados-email" v-else>
                        <label>E-mail</label>
                        <p>{{value.email}}</p>
                    </div>
                </v-flex>
                <v-flex xs12 sm4 d-flex>
                    <v-text-field
                            v-if="inserindo"
                            v-model="value.telefone"
                            required
                            label="Telefone"
                            name="Telefone"
                            placeholder="(00) 0000-0000"
                            v-mask="['(##) #####-####','(##) ####-####']"
                    ></v-text-field>
                    <div class="az-text usuario-dados-telefone" v-else>
                        <label>Telefone</label>
                        <p>{{ value.telefone | az-phone }}</p>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'UsuarioDados',
        inject: ['$validator'],
        props: {
            value: {
                required: true
            },
            inserindo: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
